import { headingText } from "../lib/format.js";
import "./CompassRose.css";

// A small visual compass showing which way the selected aircraft points.
// heading is in degrees (0 = North, 90 = East) and may be null.
export default function CompassRose({ heading }) {
  if (heading == null) return null;

  const label = headingText(heading); // e.g. "North-west (312°)"
  const deg = Math.round(heading);
  // e.g. "Heading north-west, 312 degrees"
  const words = label.replace(/\s*\(.*\)\s*$/, "").toLowerCase();
  const ariaLabel = `Heading ${words}, ${deg} degrees`;

  return (
    <div className="compass-rose">
      <svg
        className="compass-rose-svg"
        viewBox="0 0 120 120"
        width="120"
        height="120"
        role="img"
        aria-label={ariaLabel}
      >
        <g aria-hidden="true">
          <circle className="compass-ring" cx="60" cy="60" r="52" />

          <text className="cardinal cardinal-n" x="60" y="18">N</text>
          <text className="cardinal" x="106" y="65">E</text>
          <text className="cardinal" x="60" y="110">S</text>
          <text className="cardinal" x="14" y="65">W</text>

          <g
            className="compass-needle"
            style={{ transform: `rotate(${heading}deg)` }}
          >
            <polygon className="needle" points="60,14 66,64 60,58 54,64" />
            <circle className="needle-hub" cx="60" cy="60" r="4" />
          </g>
        </g>
      </svg>
      <p className="compass-label">{label}</p>
    </div>
  );
}
